package com.anjuros.website.redesign.sections.designs

import androidx.compose.runtime.Composable
import com.anjuros.website.redesign.components.RdIncludedBand
import com.anjuros.website.redesign.components.RdIncludedItem
import com.anjuros.website.redesign.util.RdIcons
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText

private val IncludedItems = listOf(
    RdIncludedItem({ RdIcons.Pencil() }, RdText.DESIGNS_INCLUDED_CUSTOM, RdText.DESIGNS_INCLUDED_CUSTOM_TEXT),
    RdIncludedItem({ RdIcons.Phone() }, RdText.DESIGNS_INCLUDED_MOBILE, RdText.DESIGNS_INCLUDED_MOBILE_TEXT),
    RdIncludedItem({ RdIcons.Code() }, RdText.DESIGNS_INCLUDED_HANDBUILT, RdText.DESIGNS_INCLUDED_HANDBUILT_TEXT),
    RdIncludedItem({ RdIcons.Mail() }, RdText.HOME_INCLUDED_FORM, RdText.HOME_INCLUDED_FORM_TEXT, RdRoute.CONTACT_FORMS),
    RdIncludedItem({ RdIcons.Clock() }, RdText.DESIGNS_INCLUDED_FAST, RdText.DESIGNS_INCLUDED_FAST_TEXT),
)

@Composable
fun DesignsIncludedSection() {
    RdIncludedBand(RdText.DESIGNS_INCLUDED_TITLE, IncludedItems)
}
